import { inject, Injectable } from '@angular/core';
import { CptCatalogueSortInput, CptQueryComplexInput, CreateBaselineCheckGQL, CreateBaselineCheckMutation, GetAllBaselineCheckGQL, GetAllBaselineCheckQuery, GetRiskMapTreeFiltersGQL, GetRiskMapTreeFiltersQuery, UpdateBaselineCheckGQL, UpdateBaselineCheckMutation } from '../../../graphql/generated';
import { map, Observable } from 'rxjs';
import { convertLazyLoadToComplexWithoutPage } from './riskmap.service';

@Injectable({
    providedIn: 'root'
})
export class BaselineCheckService {
    private readonly GetAllBaselineCheckGQL: GetAllBaselineCheckGQL = inject(GetAllBaselineCheckGQL);
    private readonly UpdateBaselineCheckGQL: UpdateBaselineCheckGQL = inject(UpdateBaselineCheckGQL);
    private readonly CreateBaselineCheckGQL: CreateBaselineCheckGQL = inject(CreateBaselineCheckGQL);
    private readonly GetRiskMapTreeFiltersGQL: GetRiskMapTreeFiltersGQL = inject(GetRiskMapTreeFiltersGQL)

    getBaselineCheck(legalEntityId: string, campaignId: string, params: any): Observable<GetAllBaselineCheckQuery['getAllBaselineCheck']> {
        const param = params ? convertLazyLoadToComplexWithoutPage(params) : null;
        return this.GetAllBaselineCheckGQL.watch({ legalEntityId, campaignId, query: param?.query as CptQueryComplexInput || null, sort: param?.sort as CptCatalogueSortInput || null }).valueChanges.pipe(map(result => result.data.getAllBaselineCheck));
    }

    getAllBaselineCheck(
        campaignId: string,
        legalEntityId: string,
        au: boolean | null
    ): Observable<GetRiskMapTreeFiltersQuery['riskMapTreeFields']> {
        return this.GetRiskMapTreeFiltersGQL.fetch({ campaignId, legalEntityId, au: null, active: true }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.riskMapTreeFields))
    }

    createBaselineCheck(campaignId: string, cptId: string, icsRationale: string, irRationale: string, legalEntityId: string): Observable<CreateBaselineCheckMutation['createBaselineCheck']> {
        return this.CreateBaselineCheckGQL.mutate(
            { campaignId, cptId, icsRationale, irRationale, legalEntityId }, { fetchPolicy: 'no-cache' })
            .pipe(map(result => result.data?.createBaselineCheck));
    }

    updateBaselineCheck(id: string, icsRationale: string, irRationale: string): Observable<UpdateBaselineCheckMutation['updateBaselineCheck']> {
        return this.UpdateBaselineCheckGQL.mutate({ id, icsRationale, irRationale }, { fetchPolicy: 'no-cache' }).pipe(map(result => result.data?.updateBaselineCheck));
    }

}